












































































































import { Component, Vue, Emit } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import RecebimentoStore from '@/components/Recebimento/Store/RecebimentoStore'
import Theme from '@/styles/Theme'
import { Loading } from '@/types/_'
import { formatValorBRL, ehValorNegativo, formatQuantidade } from '@/utils/formatacaoNumerica'
import FileSaver from 'file-saver'

@Component
export default class ComponentModalRecebimento extends Vue {
  listEmpty: boolean = false
  loading: Loading = {
    status: false,
    text: '',
  }

  readyToDownload: boolean = true

  get getRecebimentoStore() {
    return getModule(RecebimentoStore, this.$store)
  }

  get getModalRecebimento() {
    const show = this.getRecebimentoStore.modalRecebimento.detalhes

    if (show) {
      this.filtro()
      this.modelIsOpen()
    } else {
      this.modelClose()
    }

    return show
  }

  get getReadyToDownload() {
    return this.readyToDownload
  }

  set getReadyToDownload(value: boolean) {
    this.readyToDownload = value
  }

  set getModalRecebimento(value: boolean) {
    this.getRecebimentoStore.setModalRecebimentoDetalhes(value)
    if (!value) {
      this.getRecebimentoStore.clearRecebimento()
      const item: any = this.$refs.recibimentoFiltro
      if (item) {
        item.clearRange()
      }

      const modal: any = this.$refs.modalRecibimentoFiltro
      if (modal) {
        modal.clearDate()
      }
    }
  }

  get getRecebimentoItens() {
    return this.getRecebimentoStore.recebimentoItens
  }

  get getResumoProfissionais() {
    return this.getRecebimentoStore.resumoProfissionais
  }

  get totalFormatado() {
    return formatValorBRL(this.getRecebimentoItens.valorTotal)
  }

  get totalNegativo() {
    return ehValorNegativo(this.getRecebimentoItens.valorTotal)
  }

  // Derivado do resumo, que respeita os demais filtros: com profissional filtrado e a
  // quantidade daquela linha, sem filtro e a soma de todas. Evita endpoint novo de contagem.
  get qtdItensExibidos() {
    const { profissionalExecutante } = this.getRecebimentoStore.recebimentoFiltro

    if (profissionalExecutante) {
      const linha = this.getResumoProfissionais.find(p => p.id === profissionalExecutante)
      return linha ? linha.quantidadeItens : 0
    }

    return this.getResumoProfissionais.reduce((total, p) => total + p.quantidadeItens, 0)
  }

  get textoQtdItens() {
    if (this.qtdItensExibidos === 1) {
      return '1 item'
    }

    return `${formatQuantidade(this.qtdItensExibidos)} itens`
  }

  get qtdFiltrosAtivos() {
    const filtro = this.getRecebimentoStore.recebimentoFiltro
    const campos = [filtro.profissionalExecutante, filtro.paciente, filtro.procedimento, filtro.numeroAtendimento]
    const periodo = filtro.dataRealizacaoInicial || filtro.dataRealizacaoFinal

    const preenchidos = campos.filter(campo => !!campo).length

    if (periodo) {
      return preenchidos + 1
    }

    return preenchidos
  }

  get temFiltroAtivo() {
    return this.qtdFiltrosAtivos > 0
  }

  get exibirGerarRelatorioRepasse() {
    const { acoes } = this.getRecebimentoItens
    if (![null, undefined].includes(acoes)) return acoes.ExibirGerarRelatorioRepasse
    return false
  }

  get getTheme() {
    return Theme
  }

  get getRequestMessage() {
    return this.getRecebimentoStore.requestMessage
  }

  get getListEmpty() {
    return this.getRecebimentoStore.recebimentoListItemEmpty
  }

  showMoldaRecebimentoFiltro() {
    this.getRecebimentoStore.setModalRecebimentoFiltro(true)
  }

  setLoadingRequest(status: boolean, text: string) {
    this.loading.status = status
    this.loading.text = text
  }

  clearLoadingRequest() {
    this.setLoadingRequest(false, '')
  }

  ga(filtroItem) {
    this.$ga.event('recebimento', filtroItem, this.$user.profile.email)
  }

  async exportarExcel() {
    this.getReadyToDownload = false
    const request = await this.getRecebimentoStore.exportarExcel()

    const blob = new Blob([request.data], { type: 'application/vnd.ms-excel' })
    FileSaver.saveAs(blob, 'relatorio_recebimento.xlsx')
    this.getReadyToDownload = true
    this.ga('gerar-relatorio-excel')
  }

  async filtro() {
    this.getRecebimentoStore.loadProfissionaisExecutantes()
    this.getRecebimentoStore.loadResumoProfissionais()
    this.getRecebimentoStore.loadPacientes()
    this.getRecebimentoStore.loadProcedimentos()
  }

  // O resumo nao e recarregado aqui: ele ignora o filtro de profissional para permitir alternar entre eles.
  async filtrarPorProfissional(profissionalId: string) {
    this.getRecebimentoStore.recebimentoFiltro.profissionalExecutante = profissionalId

    await this.recarregarItens()

    this.ga('filtro-resumo-profissional')
  }

  async limparFiltros() {
    this.getRecebimentoStore.clearFilter()

    const modal: any = this.$refs.modalRecibimentoFiltro
    if (modal) {
      modal.clearDate()
    }

    await this.recarregarItens()
    await this.getRecebimentoStore.loadResumoProfissionais()

    this.ga('limpar-filtros-lista-vazia')
  }

  async recarregarItens() {
    this.setLoadingRequest(this.getRequestMessage.status, this.getRequestMessage.init.text)
    this.getRecebimentoStore.clearRecebimentoItens()
    await this.getRecebimentoStore.loadRecebimentoItens()
    this.clearLoadingRequest()
  }

  lockScrollPage: boolean = false

  async scrollTrigger() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(async (entry) => {
        if (entry.intersectionRatio > 0) {
          if (this.getRecebimentoStore.recebimentoItens.itens && this.getRecebimentoStore.recebimentoItens.itens.length > 0) {
            if (!this.lockScrollPage) {
              const total = this.getRecebimentoStore.recebimentoItens.itens.length
              if (this.getRecebimentoStore.totalPagina < total) {
                this.getRecebimentoStore.setTotalPagina(total)
                const pagAtual = this.getRecebimentoStore.recebimentoFiltro.pagina + 1
                this.getRecebimentoStore.setPagina(pagAtual)
                this.lockScrollPage = true
                this.setLoadingRequest(this.getRequestMessage.status, this.getRequestMessage.init.text)

                await this.getRecebimentoStore.loadRecebimentoItens()

                this.clearLoadingRequest()
                this.lockScrollPage = false
              }
            }
          }
        }
      })
    })

    observer.observe(this.$refs.infinitescrolltrigger as Element)
  }

  mounted() {
    this.scrollTrigger()
  }

  modelIsOpen() {
    const html = document.querySelector('html')
    const noOverflowClass = 'modal-is-open'
    if (html) {
      html.classList.add(noOverflowClass)
    }
  }

  modelClose() {
    const html = document.querySelector('html')
    const noOverflowClass = 'modal-is-open'
    if (html) {
      html.classList.remove(noOverflowClass)
    }
  }
}
